import { Link, useParams } from "react-router-dom";
import servicesData from "../data/servicesData";
import "../styles/service-page.css";

export default function ServicePage({ language }) {
  const { slug } = useParams();

  const labels = {
    en: {
      back: "← Back to Services",
      kicker: "MATNEU SERVICE",
      request: "Request This Service",
      explore: "Explore Details",
      overview: "Overview",
      defaultDescription:
        "A premium growth solution designed to help your business compete, scale, and win online through modern systems, strategy, automation, and digital infrastructure.",
      included: "What’s Included",
      includedTitle: "Everything You Need To Grow",
      benefits: "Benefits",
      growthTitle1: "Built For",
      growthTitle2: "Modern Growth",
      growthText:
        "Every MATNEU solution is designed to reduce friction, increase visibility, improve conversion, and create scalable systems for long-term business growth.",
      process: "Process",
      processTitle: "How We Build Momentum",
      ctaKicker: "Let’s Build",
      ctaTitle1: "Ready To Launch",
      ctaTitle2: "This Service?",
      ctaText:
        "Let’s create a premium strategy designed around your business goals, growth stage, and digital infrastructure.",
      ctaButton: "Start The Conversation",
      notFound: "Service Not Found",
      notFoundText: "The service you are looking for does not exist.",
      backHome: "Back Home",
    },

    es: {
      back: "← Volver a Servicios",
      kicker: "SERVICIO MATNEU",
      request: "Solicitar Este Servicio",
      explore: "Ver Detalles",
      overview: "Resumen",
      defaultDescription:
        "Una solución premium de crecimiento diseñada para ayudar a tu negocio a competir, escalar y ganar online mediante sistemas modernos, estrategia, automatización e infraestructura digital.",
      included: "Qué Incluye",
      includedTitle: "Todo Lo Que Necesitas Para Crecer",
      benefits: "Beneficios",
      growthTitle1: "Diseñado Para",
      growthTitle2: "Crecimiento Moderno",
      growthText:
        "Cada solución de MATNEU está diseñada para reducir fricción, aumentar visibilidad, mejorar la conversión y crear sistemas escalables para el crecimiento a largo plazo.",
      process: "Proceso",
      processTitle: "Cómo Construimos Impulso",
      ctaKicker: "Construyamos",
      ctaTitle1: "¿Listo Para Lanzar",
      ctaTitle2: "Este Servicio?",
      ctaText:
        "Creemos una estrategia premium diseñada según los objetivos, etapa de crecimiento e infraestructura digital de tu negocio.",
      ctaButton: "Iniciar Conversación",
      notFound: "Servicio No Encontrado",
      notFoundText: "El servicio que buscas no existe.",
      backHome: "Volver Al Inicio",
    },
  };

  const copy = labels[language] || labels.en;
  const service = servicesData[language]?.[slug];

  if (!service) {
    return (
      <main className="service-page">
        <section className="service-not-found">
          <span className="service-kicker">404</span>

          <h1>{copy.notFound}</h1>

          <p>{copy.notFoundText}</p>

          <Link to="/" className="service-btn">
            {copy.backHome}
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="service-page">
      <section className="service-hero">
        <Link to="/#services" className="service-back">
          {copy.back}
        </Link>

        <span className="service-kicker">{copy.kicker}</span>

        <h1>
          {service.title}
          <span>.</span>
        </h1>

        <p>{service.hero || service.subtitle}</p>

        <div className="service-hero-actions">
          <a href="/#contact" className="service-btn">
            {copy.request}
          </a>

          <a href="#service-details" className="service-btn secondary">
            {copy.explore}
          </a>
        </div>
      </section>

      <section id="service-details" className="service-intro">
        <div>
          <span className="service-kicker">{copy.overview}</span>
          <h2>{service.subtitle}</h2>
        </div>

        <p>{service.description || copy.defaultDescription}</p>
      </section>

      {service.includes && (
        <section className="service-section">
          <div className="service-section-header">
            <span className="service-kicker">{copy.included}</span>
            <h2>{copy.includedTitle}</h2>
          </div>

          <div className="service-grid">
            {service.includes.map((item, index) => (
              <article className="service-feature-card" key={item}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h3>{item}</h3>
              </article>
            ))}
          </div>
        </section>
      )}

      {service.benefits && (
        <section className="service-section service-split">
          <div>
            <span className="service-kicker">{copy.benefits}</span>

            <h2>
              {copy.growthTitle1}
              <br />
              <span>{copy.growthTitle2}</span>
            </h2>

            <p>{copy.growthText}</p>
          </div>

          <div className="service-benefits">
            {service.benefits.map((benefit) => (
              <div className="service-benefit" key={benefit}>
                <strong>✓</strong>
                <p>{benefit}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      {service.process && (
        <section className="service-section">
          <div className="service-section-header">
            <span className="service-kicker">{copy.process}</span>
            <h2>{copy.processTitle}</h2>
          </div>

          <div className="service-process">
            {service.process.map((step, index) => (
              <article className="service-process-step" key={step}>
                <span>0{index + 1}</span>
                <h3>{step}</h3>
              </article>
            ))}
          </div>
        </section>
      )}

      <section className="service-cta">
        <span className="service-kicker">{copy.ctaKicker}</span>

        <h2>
          {copy.ctaTitle1}
          <br />
          {copy.ctaTitle2}
        </h2>

        <p>{copy.ctaText}</p>

         <a href="https://wa.me/+16893403293" className="btn-primary">
          {copy.ctaButton}
        </a>
      </section>
    </main>
  );
}